import AuthorizationWrapper from "../AuthorizationWrapper";
import { Grid, MenuItem, Select, Typography } from "@material-ui/core";
import React from "react";
import withIntl from "../../utils/withIntl";

export const settings = [
  { label: "None", value: null },
  { label: "I Love Sushi", value: 1 },
];

function TaMasterMerchantSetting(props) {
  return (
    <AuthorizationWrapper
      permission={props.authenticationName}
      child={(write) => {
        return (
          <Grid container alignItems={"center"} spacing={1}>
            <Grid item xs={4}>
              <Select
                style={{ width: "95%" }}
                disabled={!write}
                value={props.setting.value}
                onChange={(e) => props.onChange(e.target.value)}
              >
                {settings.map((setting) => {
                  return <MenuItem value={setting.value}>{setting.label}</MenuItem>;
                })}
              </Select>
            </Grid>
            <Grid item xs={8}>
              <Typography>{props.label}</Typography>
            </Grid>
          </Grid>
        );
      }}
    />
  );
}

export default withIntl(TaMasterMerchantSetting);
